import { Link } from 'react-router-dom';

function Auth() {
  return (
    <Link to={'/'}>- Auth Pokedex -</Link>

    )
}

export default Auth